/* Restyle only existing display stars; never change scores or review form inputs. */
(() => {
  const fills = { '\ue000': '100%', '\ue001': '0%', '\ue002': '50%' };
  const bind = (widget) => {
    if (widget.dataset.tfbReviewsBound) return;
    widget.dataset.tfbReviewsBound = 'true';
    const refresh = () => {
      widget.querySelectorAll('.jm-star-rating[role="img"] .jm-star-rating__font-icon').forEach((star) => {
        const fill = fills[star.textContent.trim()];
        if (!fill) return;
        star.style.setProperty('--tfb-star-fill', fill);
        star.classList.add('tfb-review-star');
      });
    };
    refresh();
    new MutationObserver(refresh).observe(widget, { childList: true, subtree: true, characterData: true });
  };
  const init = () => document.querySelectorAll('.jdgm-review-widget').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
